import React from "react";
import Slider from "@mui/material/Slider";
import Switch from "@mui/material/Switch";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import MetronomeIcon from "@mui/icons-material/Timer";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import { useDAW } from "./DAWProvider";
import { KITS } from "./sampleKits";

export default function DAWToolbar() {
  const { bpm, setBpm, swing, setSwing, volume, changeVolume, metronomeOn, setMetronomeOn, kit, switchKit, canEditTransport } = useDAW();

  const disabled = !canEditTransport;

  return (
    <div className="daw-toolbar">
      <select
        className="daw-toolbar__kit-select"
        value={kit.id}
        onChange={(e) => switchKit(e.target.value)}
        disabled={disabled}
      >
        {KITS.map((k) => (
          <option key={k.id} value={k.id}>{k.name}</option>
        ))}
      </select>

      <div className="daw-toolbar__control">
        <label className="daw-toolbar__label">BPM: {bpm}</label>
        <Slider
          value={bpm}
          onChange={(_, val) => setBpm(val)}
          min={40}
          max={300}
          size="small"
          disabled={disabled}
          sx={{ width: 140, color: "#EE772F" }}
        />
      </div>

      <div className="daw-toolbar__control">
        <ShuffleIcon sx={{ color: swing > 0 ? "#EE772F" : "#666", fontSize: 18 }} />
        <label className="daw-toolbar__label" style={{ minWidth: 40 }}>Swing: {swing}%</label>
        <Slider
          value={swing}
          onChange={(_, val) => setSwing(val)}
          min={0}
          max={75}
          size="small"
          disabled={disabled}
          sx={{ width: 80, color: "#EE772F" }}
        />
      </div>

      <div className="daw-toolbar__control">
        <MetronomeIcon sx={{ color: metronomeOn ? "#EE772F" : "#666", fontSize: 20 }} />
        <Switch
          checked={metronomeOn}
          onChange={(e) => setMetronomeOn(e.target.checked)}
          size="small"
          disabled={disabled}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: "#EE772F" },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#EE772F" },
          }}
        />
      </div>

      <div className="daw-toolbar__control">
        <VolumeUpIcon sx={{ color: "#999", fontSize: 20 }} />
        <Slider
          value={volume}
          onChange={(_, val) => changeVolume(val)}
          min={0}
          max={100}
          size="small"
          disabled={disabled}
          sx={{ width: 100, color: "#EE772F" }}
        />
      </div>
    </div>
  );
}
